
<Container
	:gap="12"
	:padding="0"
	overflow="visible"
	align="left center"
	class="flow-avatar-uploader"
	@click.native="handleClick"
	@drop.native.prevent="dropFile($event)"
	@dragover.native.prevent="() => {}"
>
	<input ref="fileInput" :accept="accept" type="file" @input="selectFile" />
	<Pictogram
		v-if="avatar.type === 'label'"
		state="avatar"
		:label="avatar.label"
		size="medium"
		shape="circle"
	></Pictogram>
	<Pictogram v-if="avatar.type === 'icon'" size="medium" shape="circle">
		<Icon :name="avatar.icon" type="filled" :effects="false" />
	</Pictogram>
	<Pictogram v-if="avatar.type === 'file'" size="medium" shape="circle" type="transparent">
		<img :src="avatar.src" />
	</Pictogram>
	<Button
		v-if="avatar.type === 'file'"
		type="error"
		state="icon"
		size="small"
		class="avatar-remove-btn"
		@click.prevent.stop="removeFile()"
	>
		<Icon name="i-close" type="filled" :effects="false" size="xx-small" />
	</Button>
	<Container type="block" direction="column" :gap="0" :padding="0" align="left center">
		<Button type="default" size="small" class="flow-upload-btn" @click.prevent="() => {}">{{
			buttonText
		}}</Button>
		<Typography type="p3" color="light" class="flow-avatar-uploader-subtitle">
			{{ info }}
		</Typography>
	</Container>
</Container>
